module.exports = __webpack_public_path__ + "img/daruntereinfuegen.a7d997a.svg";